import { render, staticRenderFns } from "./multiAddView.vue?vue&type=template&id=52b70b30"
import script from "./multiAddView.vue?vue&type=script&lang=js"
export * from "./multiAddView.vue?vue&type=script&lang=js"
import style0 from "./multiAddView.vue?vue&type=style&index=0&id=52b70b30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports